import { successAction } from './actionTypes';
import { SESSION_STARTED, SESSION_FINISHED } from './session/actionTypes';
import { GET_TARGETING_INFO } from './targetingInfo/actionTypes';
import { GET_PRIVATE_INFO } from './privateInfo/actionTypes';
import { GET_DIGITAL_FINGERPRINT } from './digitalFingerprint/actionTypes';
import logger from '../services/logger';

export default {
  async [successAction(SESSION_STARTED)]({ dispatch }) {
    logger.log({
      type: 'SESSION_STARTED',
    });
    dispatch(GET_TARGETING_INFO);
    dispatch(GET_PRIVATE_INFO);
    dispatch(GET_DIGITAL_FINGERPRINT);
  },
  [successAction(SESSION_FINISHED)]() {},
};
